import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_lklog-partner/artifacts/wr2fd9vu_Screenshot%202026-04-21%20at%2018-27-46%20f4840f6c-460f-436d-a901-b056ce3790cf.png%20%28PNG%20Image%201536%20%C3%97%201024%20pixels%29.png";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-white/10 bg-[#0A0A0A] pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="LK LOG" className="w-11 h-11 rounded-sm object-contain border border-[#F2B705]/30" />
              <div className="flex flex-col leading-none">
                <span className="font-display text-xl font-bold tracking-tight">
                  LK <span className="text-[#F2B705]">LOG</span>
                </span>
                <span className="text-[10px] tracking-[0.22em] uppercase text-neutral-400 mt-1">
                  Transport &amp; Spedycja
                </span>
              </div>
            </div>
            <p className="text-xs tracking-[0.2em] uppercase text-[#F2B705]/80 mb-4">
              {t("hero.tagline")}
            </p>
            <p className="text-sm text-neutral-400 max-w-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <div className="label-gold mb-5">{t("footer.sections")}</div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li><Link to="/" data-testid="footer-link-home" className="hover:text-[#F2B705]">{t("nav.home")}</Link></li>
              <li><Link to="/o-nas" data-testid="footer-link-about" className="hover:text-[#F2B705]">{t("nav.about")}</Link></li>
              <li><Link to="/uslugi" data-testid="footer-link-services" className="hover:text-[#F2B705]">{t("nav.services")}</Link></li>
              <li><Link to="/branze" data-testid="footer-link-industries" className="hover:text-[#F2B705]">{t("nav.industries")}</Link></li>
              <li><Link to="/adr" data-testid="footer-link-adr" className="hover:text-[#F2B705]">{t("nav.adr")}</Link></li>
              <li><Link to="/solutio" data-testid="footer-link-solutio" className="hover:text-[#F2B705]">{t("nav.solutio")}</Link></li>
              <li><Link to="/kontakt" data-testid="footer-link-contact" className="hover:text-[#F2B705]">{t("nav.contact")}</Link></li>
            </ul>
          </div>

          <div>
            <div className="label-gold mb-5">{t("footer.contact")}</div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#F2B705] mt-1 shrink-0" strokeWidth={1.5} />
                <span>
                  {t("contact.address_name")}<br />
                  {t("contact.address_line1")}<br />
                  {t("contact.address_line2")}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#F2B705] shrink-0" strokeWidth={1.5} />
                <a href="tel:+48660341213" className="hover:text-[#F2B705]">+48 660 341 213</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#F2B705] shrink-0" strokeWidth={1.5} />
                <a href="mailto:p.chudy@lklog.pl" className="hover:text-[#F2B705]">p.chudy@lklog.pl</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-neutral-500">
          <span>© {new Date().getFullYear()} LK LOG Karol Lewandowski. {t("footer.copyright")}</span>
          <span className="tracking-widest">PREMIUM LOGISTICS · PL · EU</span>
        </div>
      </div>
    </footer>
  );
}
